"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Success = _interopRequireDefault(require("./Success"));

var _Failed = _interopRequireDefault(require("./Failed"));

function getAccounts(accounts) {
  var result = [];

  for (var currency in accounts) {
    if (accounts.hasOwnProperty(currency)) {
      var account = accounts[currency];
      result.push({
        currency: currency,
        balance: account['available']
      });
    }
  }

  return result;
}

function getAmounts(summary) {
  var result = [];

  for (var currency in summary) {
    if (summary.hasOwnProperty(currency)) {
      var account = summary[currency];
      var amountMethods = [];

      for (var method in account) {
        if (account.hasOwnProperty(method)) {
          var item = account[method];
          amountMethods.push({
            currency: currency,
            amount: item['amount'],
            amountWithCommission: item['amountWithCommission']
          });
        }
      }

      result.push(amountMethods);
    }
  }

  return result;
}

function Alerts(_ref) {
  var items = _ref.items,
      summary = _ref.summary,
      success = _ref.success,
      shop = _ref.shop,
      isOverBalance = _ref.isOverBalance,
      commonErrors = _ref.commonErrors;
  var accounts = getAccounts(items);
  var amounts = getAmounts(summary);
  return success ? /*#__PURE__*/_react["default"].createElement(_Success["default"], {
    accounts: accounts,
    amounts: amounts,
    hasCommissions: shop['isShowCommissionCalculation']
  }) : /*#__PURE__*/_react["default"].createElement(_Failed["default"], {
    commonErrors: commonErrors,
    isOverBalance: isOverBalance
  });
}

var _default = Alerts;
exports["default"] = _default;